import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, signInWithGoogle } from "./UsersConfig/Authfirebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Users.css";
import { validEmail } from "../Tools/ValidateData";
import Alert from 'react-bootstrap/Alert';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      // Puedes mostrar una pantalla de carga aquí
      return;
    }
    if (user) navigate("/dashboard");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    if (!validEmail.test(email)) {
      showErrorms("Proporcionar un Email válido");
      return;
    }
    if (!password) {
      showErrorms("Proporcionar Password");
      return;
    }

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log("Iniciar sesión");
        console.log(user);
      })
      .catch((error) => {
        console.log(error.message);
        showErrorms("Usuario incorrecto");
      });
  };

  const showErrorms = (msg) => {
    setErrorMsg(msg);
    setShowError(true);
  };

  return (
    <div className="containerUser">
      <img src={process.env.PUBLIC_URL + "/Logo.png"} alt="Empresa" />
      <h3>Iniciar sesión</h3>

      <Alert variant="danger" onClose={() => setShowError(false)} dismissible show={showError}>
        <Alert.Heading>Revisar!</Alert.Heading>
        <p>{errorMsg}</p>
      </Alert>

      <input
        type="text"
        className="bsInput"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="📧 E-mail"
      />
      <input
        type="password"
        className="bsInput"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
      />
      <button className="bsButton" onClick={handleLogin}>
        🔑 Login
      </button>

      <div>
        <Link to="/reset">Olvide la contraseña</Link>
      </div>
      <div>
        ¿Todavía no tienes cuenta? <Link to="/register"> 😀 Registrate </Link>.
      </div>
      <span>O</span>
      <h5>Iniciar sesión con Gmail</h5>
      <button className="bsButton2" onClick={signInWithGoogle}>
        Login con Gmail
      </button>
    </div>
  );
}

export default Login;
